import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';
import SafeMuiDatatable from '../generic_components/SafeMuiDatatable';
import TEXT from '../text';
import counterPartColumns from './CounterPartColumns';

const toCounterPartMarkListItem = data => ({
  id: data.counterPart._id,
  companyId: data.companyId,
  salutation: data.counterPart.salutation,
  title: data.counterPart.title,
  firstName: data.counterPart.firstName,
  lastName: data.counterPart.lastName,
  faxNumber: data.counterPart.contactInfo.faxNumber,
  phoneNumber: data.counterPart.contactInfo.phoneNumber,
  phoneNumberMobile: data.counterPart.contactInfo.phoneNumberMobile,
  mailAddress: data.counterPart.contactInfo.mailAddress,
  division: data.counterPart.division,
  hierarchyLevel: data.counterPart.hierarchyLevel,
  position: data.counterPart.position
});

// Row data for the table: id at position 0 (excluded column), then display columns
const toCounterPartTableRow = data => [
  data.counterPart._id,
  data.counterPart.salutation,
  data.counterPart.title,
  data.counterPart.firstName,
  data.counterPart.lastName,
  data.counterPart.contactInfo.faxNumber,
  data.counterPart.contactInfo.phoneNumber,
  data.counterPart.contactInfo.phoneNumberMobile,
  data.counterPart.contactInfo.mailAddress,
  data.counterPart.division,
  data.counterPart.hierarchyLevel,
  data.counterPart.position
];

const CounterPartTable = ({ counterPartList = [], onCounterPartClick, handleSnackbarOpen }) => {
  const filteredCounterPartList = useMemo(() => counterPartList.filter(item => item.counterPart !== null), [counterPartList]);

  const preparedData = useMemo(() => filteredCounterPartList.map(toCounterPartTableRow), [filteredCounterPartList]);

  const unformatedData = useMemo(() => filteredCounterPartList.map(toCounterPartMarkListItem), [filteredCounterPartList]);

  const tableOptions = useMemo(
    () => ({
      selectableRows: 'none',
      setRowProps: () => ({
        style: { cursor: 'pointer' }
      })
    }),
    []
  );

  const handleOnRowClick = useCallback(
    /**
     *
     * @param {string[]} rowData
     * @param {{dataIndex: number}} rowMeta
     */
    (rowData, rowMeta) => {
      const selectedCounterPart = filteredCounterPartList[rowMeta.dataIndex];
      // Store the currently displayed counterpart list for arrow navigation in CompanyArchive
      const navList = filteredCounterPartList.map(item => ({
        id: String(item.counterPart._id),
        companyId: item.companyId
      }));
      sessionStorage.setItem('counterPartNavigationList', JSON.stringify(navList));
      onCounterPartClick(String(selectedCounterPart.counterPart._id), selectedCounterPart.companyId);
    },

    [filteredCounterPartList, onCounterPartClick]
  );
  return (
    <div className="h-100 pt-2">
      <SafeMuiDatatable
        title={
          <Box display="flex">
            <Typography variant="h6">{TEXT.tableTitle}</Typography>
          </Box>
        }
        onRowClick={handleOnRowClick}
        tableName="CounterPartTable"
        columns={counterPartColumns.DEFAULT_COLUMNS}
        data={preparedData}
        options={tableOptions}
        showMarklistButton
        markListType="counterPart"
        unformatedData={unformatedData}
        handleSnackbarOpen={handleSnackbarOpen}
      />
    </div>
  );
};

CounterPartTable.propTypes = {
  counterPartList: PropTypes.array.isRequired,
  onCounterPartClick: PropTypes.func.isRequired,
  handleSnackbarOpen: PropTypes.func.isRequired
};

export default CounterPartTable;
